import { variant } from 'styled-system';

import { TokenizedVariantArg } from './types';

const HACKY_FIX_VARIANTS = {
  __: {},
};
export const tokenizedVariant = ({
  scale: _scale,
  prop,
}: TokenizedVariantArg) => {
  const scale = `components.${_scale}.variants.${prop}`;
  return variant({ prop, variants: HACKY_FIX_VARIANTS, scale });
};
